import { BaseRepository } from './BaseRepository';
import { getDatabase, NexxusDatabase } from './NexxusDatabase';
import type { Salarie } from '@shared/types/Salarie';

export class SalarieRepository extends BaseRepository<Salarie> {
  constructor(db?: NexxusDatabase) {
    super((db ?? getDatabase()).salaries);
  }
  async findByTenantAndStatut(tenant_id: string, statut: Salarie['statut']): Promise<Salarie[]> {
    return this.table.where('[tenant_id+statut]').equals([tenant_id, statut]).toArray();
  }
  async findActifs(tenant_id: string): Promise<Salarie[]> {
    return this.findByTenantAndStatut(tenant_id, 'actif');
  }
  async findByMatricule(tenant_id: string, matricule: string): Promise<Salarie | null> {
    const result = await this.table.where({ tenant_id, matricule }).first();
    return result ?? null;
  }
}
